// ── AUTO-CLOSE SIBLING SUBMENUS ──
document.addEventListener('click', function (e) {
  const clickedDetails = e.target.closest('.header__submenu details');

  document.querySelectorAll('.header__submenu details[open]').forEach(function (openDetails) {
    if (openDetails !== clickedDetails) {
      openDetails.removeAttribute('open');
    }
  });
});

